const stamp = (iso) => iso.replaceAll("-", "");
const nextDay = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

export function downloadIcs(plan) {
  const text = `Your AHU check-in. ${plan.content.accountability}`.replace(/[,;]/g, (m) => `\\${m}`).replace(/\n/g, "\\n");
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//AHU Coach//EN", "BEGIN:VEVENT",
    `UID:${plan.id}@ahucoach.com`, `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").slice(0, 15)}Z`,
    `DTSTART;VALUE=DATE:${stamp(plan.checkin_date)}`, `DTEND;VALUE=DATE:${stamp(nextDay(plan.checkin_date))}`,
    `SUMMARY:AHU check-in: ${plan.title}`, `DESCRIPTION:${text}`, "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  Object.assign(document.createElement("a"), { href: url, download: "ahu-check-in.ics" }).click();
  URL.revokeObjectURL(url);
}

export const googleCalUrl = (plan) =>
  `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(`AHU check-in: ${plan.title}`)}&dates=${stamp(plan.checkin_date)}/${stamp(nextDay(plan.checkin_date))}&details=${encodeURIComponent(plan.content.accountability)}`;
